import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../home/redux/actions';
import TopicCard from './components/TopicCard';
import {
    COMMENT_COUNT_FOR_APRIL_2024_KEY,
    DECEPTION_AND_MANIPULATION_CATEGORY,
    DECEPTION_AND_MANIPULATION_LANDING_PAGE_TOPICS,
    FAILED_TO_SELECT_TOPIC_TOAST_MESSAGE,
    GENERAL_CATEGORY,
    GENERAL_LANDING_PAGE_TOPICS,
    HARM_TO_HEALTH_AND_WELL_BEING_CATEGORY,
    HARM_TO_HEALTH_AND_WELL_BEING_LANDING_PAGE_TOPICS,
    HARM_TO_ORGANIZATIONS_AND_BRANDS_CATEGORY,
    HARM_TO_ORGANIZATIONS_AND_BRANDS_LANDING_PAGE_TOPICS,
    HATE_AND_DISCRIMINATION_CATEGORY,
    HATE_AND_DISCRIMINATION_LANDING_PAGE_TOPICS, SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY,
    THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY,
    THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_LANDING_PAGE_TOPICS, TOPIC_CATEGORY_KEY, TOPIC_ID_KEY,
    TOPIC_IMAGE_ATTRIBUTION_KEY,
    TOPIC_IMAGE_NAME_KEY,
    TOPIC_NAME_KEY,
    TOPIC_NOT_IMPLEMENTED_ALERT_MESSAGE,
} from './constants';
import * as topicActions from '../topics/redux/actions';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import http from '../../common/http';
import { apiEndPoints } from '../../common/globalConstants';
import { getLoginRedirectUrl } from '../home/sharedFunctions';

export class LandingPage extends Component {

    static propTypes = {
        actions: PropTypes.object.isRequired,
        topicActions: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        home: PropTypes.object.isRequired,
        topics: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            prevTopic: null,
            clickedTopic: {
                [TOPIC_NAME_KEY]: null,
                [TOPIC_IMAGE_NAME_KEY]: null,
                [TOPIC_IMAGE_ATTRIBUTION_KEY]: null,
                [TOPIC_ID_KEY]: null,
                [TOPIC_CATEGORY_KEY]: null,
                [COMMENT_COUNT_FOR_APRIL_2024_KEY]: null,
                [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: null,
            },
            allTopicsInDB: [],
            allTopicIdsInDb: [],
            isSelectingTopic: false,
            updateTopicsdropdownBegin: false,
            updateSelectedTopicBegin: false,
            isRetrievingTopics: false
        };
    }

    handleTopicCardClicked = (topic,prevTopic) => {
        const {allTopicIdsInDb} = this.state;
        if (! topic.topicId || ! allTopicIdsInDb.includes(topic.topicId)) {
            alert(TOPIC_NOT_IMPLEMENTED_ALERT_MESSAGE);
            return;
        }
        this.setState({isSelectingTopic: true, clickedTopic: topic},() => {
            topic.status=true;
            if (prevTopic) {
                prevTopic.status=false;
            }
            this.props.actions.updateSelectedTopic({
                updatedTopic: topic,
                prevTopic: prevTopic
            });
            this.props.actions.updateTopicsDropdown({
                updatedTopic: topic,
                prevTopic: prevTopic
            });
        });

    }

    componentDidMount() {
        const checkAuthTokenRequest = http.get(apiEndPoints.authentication.CHECK_TOKEN);
        checkAuthTokenRequest.then(
          response => {
              this.props.topicActions.retrieveTopics();
          },
          error => {
              this.props.history.push(getLoginRedirectUrl());
              return false;
          },
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.processPropsForSelectingTopic();
        this.processPropsForUpdatedListOfTopics();
    }

    processPropsForSelectingTopic() {
        const {isSelectingTopic, updateTopicsdropdownBegin,updateSelectedTopicBegin} = this.state;

        if (!isSelectingTopic) {
            return;
        }
        if (updateTopicsdropdownBegin && updateSelectedTopicBegin) {
            if (this.props.home.updateSelectedTopicFailure || this.props.home.updateTopicsdropdownError) {
                toast.error(FAILED_TO_SELECT_TOPIC_TOAST_MESSAGE);
                this.setState({
                    isSelectingTopic: false,
                    updateTopicsdropdownBegin: false,
                    updateSelectedTopicBegin: false
                });
            }
            if (this.props.home.updateSelectedTopicSuccess && this.props.home.updateTopicsdropdownSuccess) {
                this.setState({
                    isSelectingTopic: false,
                    updateTopicsdropdownBegin: false,
                    updateSelectedTopicBegin: false
                }, () => {
                    if (this.state.clickedTopic[SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]) {
                        this.props.history.push("harmwatch");
                    }
                    else {
                        this.props.history.push("/dashboard");
                    }
                });
            }
        }

        if (this.doesPropsShowUpdateSelectedTopicBackendRequestHasBegun()) {
            this.setState({updateSelectedTopicBegin: this.props.home.updateSelectedTopicBegin});
        }
        if (this.doesPropsShowUpdateTopicsdropdownBackendRequestHasBegun()) {
            this.setState({updateTopicsdropdownBegin: this.props.home.updateTopicsdropdownBegin});
        }
    }

    doesPropsShowUpdateTopicsdropdownBackendRequestHasBegun() {
        const {updateTopicsdropdownBegin} = this.state;
        return (!updateTopicsdropdownBegin && JSON.stringify(updateTopicsdropdownBegin) !== JSON.stringify(this.props.home.updateTopicsdropdownBegin));
    }

    doesPropsShowUpdateSelectedTopicBackendRequestHasBegun() {
        const {updateSelectedTopicBegin} = this.state;
        return (!updateSelectedTopicBegin && JSON.stringify(updateSelectedTopicBegin) !== JSON.stringify(this.props.home.updateSelectedTopicBegin));
    }

    processPropsForUpdatedListOfTopics() {
        if (this.doesPropsHaveUpdatedListOfTopics()) {
            let allTopicIdsInDb = [];
            let prevTopic = null;
            for (let topic of this.props.topics.allTopics.data) {
                allTopicIdsInDb.push(topic.topicId);
                if (topic.status === true) {
                    prevTopic = topic;
                }
            }
            this.setState({
                prevTopic: prevTopic,
                allTopicsInDB: this.props.topics.allTopics.data,
                allTopicIdsInDb: allTopicIdsInDb
            });
        }
    }

    doesPropsHaveUpdatedListOfTopics() {
        const allTopicsInDB = this.state.allTopicsInDB;
        return (this.props.topics && this.props.topics.allTopics && this.props.topics.allTopics.data && (JSON.stringify(allTopicsInDB) !== JSON.stringify(this.props.topics.allTopics.data)));
    }

    render() {
        const {
            prevTopic
        } = this.state;

        return (
            <div className={'landing-page-container'}>
                <h5>{GENERAL_CATEGORY}</h5>
                <hr />
                <div className={'row'}>
                    {GENERAL_LANDING_PAGE_TOPICS.map((topic) => (
                        <TopicCard
                            topic={topic}
                            key={topic.topicName}
                            prevTopic={prevTopic}
                            handleTopicCardClicked={this.handleTopicCardClicked}
                        />
                    ))}
                </div>

                <h5>{DECEPTION_AND_MANIPULATION_CATEGORY}</h5>
                <hr />
                <div className={'row'}>
                    {DECEPTION_AND_MANIPULATION_LANDING_PAGE_TOPICS.map((topic) => (
                        <TopicCard
                            topic={topic}
                            key={topic.topicName}
                            prevTopic={prevTopic}
                            handleTopicCardClicked={this.handleTopicCardClicked}
                        />
                    ))}
                </div>

                <h5>{HATE_AND_DISCRIMINATION_CATEGORY}</h5>
                <hr />
                <div className={'row'}>
                    {HATE_AND_DISCRIMINATION_LANDING_PAGE_TOPICS.map((topic) => (
                        <TopicCard
                            topic={topic}
                            key={topic.topicName}
                            prevTopic={prevTopic}
                            handleTopicCardClicked={this.handleTopicCardClicked}
                        />
                    ))}
                </div>

                <h5>{HARM_TO_HEALTH_AND_WELL_BEING_CATEGORY}</h5>
                <hr />
                <div className={'row'}>
                    {HARM_TO_HEALTH_AND_WELL_BEING_LANDING_PAGE_TOPICS.map((topic) => (
                        <TopicCard
                            topic={topic}
                            key={topic.topicName}
                            prevTopic={prevTopic}
                            handleTopicCardClicked={this.handleTopicCardClicked}
                        />
                    ))}
                </div>

                <h5>{THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY}</h5>
                <hr />
                <div className={'row'}>
                    {THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_LANDING_PAGE_TOPICS.map((topic) => (
                        <TopicCard
                            topic={topic}
                            key={topic.topicName}
                            prevTopic={prevTopic}
                            handleTopicCardClicked={this.handleTopicCardClicked}
                        />
                    ))}
                </div>

                <h5>{HARM_TO_ORGANIZATIONS_AND_BRANDS_CATEGORY}</h5>
                <hr />
                <div className={'row'}>
                    {HARM_TO_ORGANIZATIONS_AND_BRANDS_LANDING_PAGE_TOPICS.map((topic) => (
                        <TopicCard
                            topic={topic}
                            key={topic.topicName}
                            prevTopic={prevTopic}
                            handleTopicCardClicked={this.handleTopicCardClicked}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        home: state.home,
        topics: state.topics,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch),
        topicActions: bindActionCreators({ ...topicActions }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/features/landing-page/LandingPage.js